module.exports = __webpack_public_path__ + "static/media/profile-8.7fccb765.png";